/**
 * Footer JavaScript - ES6 Class Based Implementation
 * Handles accordion, carousel, and social spacing with ADA compliance
 */

class FooterComponent {
  constructor() {
    this.mobileBreakpoint = 768;
    this.accordionToggles = null;
    this.resizeTimer = null;

    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeComponents();
      });
    } else {
      this.initializeComponents();
    }

    if (typeof jQuery !== 'undefined') {
      this.initMobileCarousel();
    } else {
      window.addEventListener('load', () => {
        if (typeof jQuery !== 'undefined') {
          this.initMobileCarousel();
        }
      });
    }

    window.addEventListener('resize', this.handleResize.bind(this));
  }

  initializeComponents() {
    this.initMobileAccordion();
    this.initNiceSelect();
    this.initSocialSpacing();
  }

  initMobileAccordion() {
    if (window.innerWidth > this.mobileBreakpoint) return;

    const footer =
      document.querySelector('.Footer--new') ||
      document.querySelector('footer.Footer');

    if (!footer) return;

    this.accordionToggles =
      footer.querySelectorAll('.Footer__AccordionToggle');

    if (!this.accordionToggles.length) return;

    this.accordionToggles.forEach(toggle => {
      if (toggle.hasAttribute('data-accordion-initialized')) return;

      toggle.setAttribute('data-accordion-initialized', 'true');
      toggle.setAttribute('aria-expanded', 'false');

      const content = toggle.nextElementSibling;
      if (content) {
        content.style.maxHeight = '0';
        content.setAttribute('aria-hidden', 'true');
      }

      toggle.addEventListener('click', e => {
        e.preventDefault();
        this.handleAccordionClick(toggle);
      });
    });
  }

  handleAccordionClick(currentToggle) {
    const isOpen =
      currentToggle.getAttribute('aria-expanded') === 'true';

    const content = currentToggle.nextElementSibling;
    if (!content) return;

    // Close other accordions
    this.accordionToggles.forEach(otherToggle => {
      if (otherToggle !== currentToggle) {
        otherToggle.setAttribute('aria-expanded', 'false');
        const otherContent = otherToggle.nextElementSibling;
        if (otherContent) {
          otherContent.style.maxHeight = '0';
          otherContent.setAttribute('aria-hidden', 'true');
        }
      }
    });

    // Toggle current
    if (isOpen) {
      currentToggle.setAttribute('aria-expanded', 'false');
      content.style.maxHeight = '0';
      content.setAttribute('aria-hidden', 'true');
    } else {
      currentToggle.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = content.scrollHeight + 'px';
      content.setAttribute('aria-hidden', 'false');
    }
  }

  initMobileCarousel() {
    const carousel = document.getElementById('mobrev-carousel');
    if (!carousel || typeof jQuery === 'undefined' || !jQuery.fn.carousel)
      return;

    jQuery(carousel).carousel({
      interval: parseInt(window.footerCarouselInterval || 7000, 10),
      pause: false
    });
  }

  initNiceSelect() {
    const helpType = document.getElementById('help_type');
    if (helpType && typeof jQuery !== 'undefined' && jQuery.fn.niceSelect) {
      jQuery(helpType).niceSelect();
    }
  }

  initSocialSpacing() {
    const footer =
      document.querySelector('.Footer--new') ||
      document.querySelector('footer.Footer');

    if (!footer) return;

    footer
      .querySelectorAll('.Footer__SocialList[data-icon-spacing]')
      .forEach(list => {
        const spacing = list.getAttribute('data-icon-spacing');
        if (spacing) {
          list.style.setProperty('--icon-spacing', spacing + 'px');
        }
      });
  }

  handleResize() {
    clearTimeout(this.resizeTimer);

    this.resizeTimer = setTimeout(() => {
      if (window.innerWidth <= this.mobileBreakpoint) {
        this.initMobileAccordion();
      }
    }, 250);
  }
}

// Initialize
new FooterComponent();
